export default __webpack_public_path__ + "static/media/headshot.518605b1.png";